/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { Modal, Counter } from '@components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
import { isDesktop } from 'react-device-detect';
import { verifySign } from '@api';
const LcstModal = () => {
    // 簽驗
    const [certificateNumber, setCertificateNumber] = useState('');
    // const veriObj = {};
    let tempObj = {};
    const [veriObj, setVeriObj] = useState({});
    function sign_callback(obj) {
        // veriObj.signature = obj.signed;
        // veriObj.serial = obj.casno;
        // veriObj.data = idno + ',addCollateral';
        tempObj = {};
        tempObj.signature = obj.signed;
        tempObj.serial = obj.casno;
        tempObj.data = idno.trim() + ',addCollateral';
        setVeriObj(tempObj);
        setCertificateNumber(obj.casno);
    }
    // const sign_callback = obj => {
    //     // 設false才可再次執行
    //     setmtksign(false);
    //     // 開始驗章流程
    //     veriObj.signature = obj.signed;
    //     veriObj.serial = obj.casno;
    //     verifySignFunc(veriObj).then(() => {
    //         setIsVerifyComplete(true);
    //     });
    // };

    async function verifySignFunc(veriObj) {
        const res = await verifySign(veriObj);
        if (res.data.code === '0') {
            setCertificateNumber(veriObj.serial);
        } else {
            // todo modal res.data.message
        }
        return res;
    }
    // 簽驗結束
    const {
        LoanStore: {
            amount,
            loanCstModalVisible,
            closeLoanCstModal,
            setCount,
            setCst,
            collateralStockUIList,
            getLendBusinessTime,
            transType,
            updateData,
            highGradeCollateralSwitch,
        },
        AuthStore: { borrowedAmount, idno },
    } = useStore();
    useEffect(() => {
        if (loanCstModalVisible) {
            if (!signWeb) {
                // 測試機關閉簽驗
                setCertificateNumber('test');
            } else {
                // 打開先簽章
                if (!isDesktop) {
                    const signObj = {
                        cb: sign_callback,
                    };
                    signObj.idno = idno.trim();
                    signObj.tosign = idno.trim() + ',addCollateral';
                    // veriObj.data = idno + ',addCollateral';
                    // P1
                    signObj.method = 'P7';
                    // eslint-disable-next-line no-undef
                    mtklib.sign(signObj);
                } else {
                    // 判斷web還是ap?
                    console.log(!!window.chrome.webview);
                    const capiobj = getCGCAPIATLADPTObj();
                    if (capiobj !== undefined) {
                        console.log('載入成功 !');
                        if (capiobj.NeedUpdateInstaller()) {
                            // 檢查是否有新版本要版更
                            const msg =
                                '已有新版[簽章ServiSign]元件，請重新下載及手動安裝元件後，再重新執行網頁!';
                            updateData('errMsg', msg);
                            updateData('certModalVisible', true);
                            closeLoanCstModal();
                            return;
                        }
                    } else {
                        console.log('載入失敗 !');
                        updateData('errMsg', '全景程式載入失敗');
                        updateData('certModalVisible', true);
                        closeLoanCstModal();
                        return;
                    }
                    const iKeyUsage = 0;
                    const strCSP = '';
                    const iHashFlags = 0x04; // SHA256

                    const text = idno.trim() + ',addCollateral'; // 簽章原文
                    let SignDataPC = '';
                    const id1 = 'CN=TW' + idno.trim() + '1'; // 身分證號

                    const strSubject = id1 + '\nOU=PSCNET'; // 統一證券OU
                    const strIssuer = '';
                    const strPin = '';

                    const iFlags =
                        CGCAPI_FLAG_SELCERT_AUTO +
                        '|' +
                        CGCAPI_FLAG_SELCERT_CHECKVALID;

                    let min = 10000;

                    const t1 = new Date().getTime();

                    SignDataPC = capiobj.CAPISign(
                        text,
                        'MS950',
                        strSubject,
                        strIssuer,
                        strCSP,
                        '',
                        iFlags,
                        iHashFlags,
                        iKeyUsage
                    ); // strIssure, strCSP, iKeyUsage固定
                    const t2 = new Date().getTime();
                    if (t2 - t1 < min) min = t2 - t1;
                    const rtn = capiobj.GetErrorCode();

                    if (rtn !== 0) {
                        updateData(
                            'errMsg',
                            '簽章失敗!錯誤代碼:' + GetErrorMessage(rtn)
                        );
                        updateData('certModalVisible', true);
                        closeLoanCstModal();
                    } else {
                        // 簽章成功取憑證序號
                        const subject = 'CN=TW' + idno.trim() + '1\nOU=PSCNET';
                        const flag =
                            CGCAPI_FLAG_SELCERT_AUTO +
                            '|' +
                            CGCAPI_FLAG_SELCERT_CHECKVALID;
                        const cert = capiobj.CAPI_XGetUserCertificate(
                            '',
                            subject,
                            flag,
                            0,
                            ''
                        ); // provider, keyusage, 第五個欄位為固定值
                        let rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            updateData('errMsg', '取得使用者憑證失敗' + rtn);
                            updateData('certModalVisible', true);
                            closeLoanCstModal();
                            return;
                        }
                        // 憑證取得序號
                        const serial = capiobj.CAPICertGetSerialNumber(cert, 0);
                        rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            updateData(
                                'errMsg',
                                '取得憑證序號失敗!錯誤代碼:' +
                                    GetErrorMessage(rtn)
                            );
                            updateData('certModalVisible', true);
                            closeLoanCstModal();
                            return;
                        }
                        tempObj = {};
                        tempObj.signature = SignDataPC;
                        tempObj.serial = serial;
                        tempObj.data = idno.trim() + ',addCollateral';
                        setVeriObj(tempObj);
                        setCertificateNumber(tempObj.serial);
                    }
                    // setCertificateNumber('web');
                }
            }
        }
    }, [loanCstModalVisible]);
    let loanAmount = collateralStockUIList.reduce(
        (preVal, curVal) =>
            preVal +
            ((curVal.closePrice * 1000 * curVal.accommodating) / 100) *
                curVal.cstQty,
        0
    );
    loanAmount = Math.floor(loanAmount / 1000) * 1000;
    return (
        <>
            <Modal
                show={loanCstModalVisible}
                onHide={closeLoanCstModal}
                title={'設定擔保品數量'}
            >
                <form
                    onSubmit={async e => {
                        e.preventDefault();
                        if (!signWeb) {
                            // 測試機關閉簽驗
                            updateData('certificateNumber', certificateNumber);
                        } else {
                            const verifyResult = await verifySignFunc(veriObj);
                            updateData('certificateNumber', certificateNumber);
                            if (verifyResult.data.code !== '0') {
                                updateData('errMsg', verifyResult.data.message);
                                updateData('certModalVisible', true);
                                closeLoanCstModal();
                                return;
                            }
                        }
                        // 簽驗
                        // 簽驗結束
                        closeLoanCstModal();
                        const cstArr = collateralStockUIList.filter(
                            cst => cst.cstQty > 0
                        );
                        const detailList = cstArr.map(
                            ({
                                stockNo: collateralId,
                                cstQty: qty,
                                stockName: collateralName,
                            }) => ({
                                collateralId,
                                qty,
                                collateralName,
                            })
                        );
                        const postData = { detailList, certificateNumber };
                        await getLendBusinessTime();
                        if (
                            transType === 'E1' ||
                            transType === 'E2' ||
                            transType === 'E3'
                        ) {
                            updateData('transInfoModalVisible', true);
                            updateData('applyDisabled', true);
                        } else {
                            updateData('transInfoModalVisible', false);
                            updateData('applyDisabled', false);
                            setCst(postData);
                        }
                    }}
                >
                    <p className="nol-pr mb-3">
                        您的尚可借金額
                        <b className="price">
                            <span>$</span>
                            {addCommas(borrowedAmount)}
                        </b>
                        ，申請借款
                        <b className="red price">
                            <span>$</span>
                            {addCommas(
                                removeNonNumeric(
                                    Math.floor(removeCommas(amount) / 1000) *
                                        1000
                                )
                            )}
                        </b>
                        ，請選擇增加的擔保品
                    </p>
                    <h4 className="title fw-bolder mb-2">
                        可作為擔保品的庫存明細
                    </h4>

                    <p className="title d-sm-none text-end">
                        前一營業日報價資訊
                    </p>
                    <ul className="stock-list d-sm-none">
                        {collateralStockUIList.map(
                            (
                                {
                                    stockNo,
                                    stockName,
                                    accommodating,
                                    stockQty,
                                    closePrice,
                                    insiderFlag,
                                    cstQty,
                                    hQFlag,
                                },
                                index
                            ) => {
                                return (
                                    <li
                                        key={`collateralStockUIList ${index}`}
                                        className="d-flex flex-wrap py-2 px-3 mb-3"
                                    >
                                        <div className="stock-choose d-flex  mb-2">
                                            <div className="stock-name text-black2 col-8">
                                                <span className="me-2">
                                                    {stockNo}
                                                </span>
                                                {stockName}
                                            </div>

                                            {!insiderFlag ? (
                                                !!accommodating && (
                                                    // 新版Counter，增加文字輸入，待統一提出需求即可開啟
                                                    <Counter
                                                        value={cstQty || 0}
                                                        stockAmount={
                                                            (hQFlag === 1 &&
                                                                highGradeCollateralSwitch ===
                                                                    true) ||
                                                            !highGradeCollateralSwitch
                                                                ? stockQty
                                                                : 0
                                                        }
                                                        increase={() => {
                                                            setCount({
                                                                index,
                                                                value:
                                                                    cstQty + 1,
                                                            });
                                                        }}
                                                        decrease={() => {
                                                            setCount({
                                                                index,
                                                                value:
                                                                    cstQty - 1,
                                                            });
                                                        }}
                                                        onChange={e => {
                                                            if (
                                                                isNaN(
                                                                    e.target
                                                                        .value
                                                                )
                                                            ) {
                                                                e.target.value = 0;
                                                            }

                                                            if (
                                                                parseInt(
                                                                    e.target
                                                                        .value
                                                                ) > stockQty
                                                            ) {
                                                                e.target.value =
                                                                    stockQty;
                                                            }
                                                            setCount({
                                                                index,
                                                                value: +e.target
                                                                    .value,
                                                            });
                                                        }}
                                                    />
                                                )
                                            ) : (
                                                <b className="text-danger ps-3">
                                                    內部人
                                                </b>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-baseline">
                                            <div className="stock-number d-flex me-2 align-items-baseline">
                                                <small className="gray-light me-1">
                                                    張數
                                                </small>
                                                <span className="text-black2">
                                                    {stockQty}
                                                </span>
                                            </div>
                                            <div className="stock-number d-flex me-2 align-items-baseline">
                                                <small className="gray-light me-1">
                                                    收盤
                                                </small>
                                                <span
                                                    className={`price text-black2 ${
                                                        !accommodating ||
                                                        insiderFlag
                                                            ? 'opacity-50'
                                                            : ''
                                                    }`}
                                                >
                                                    <span>$</span>
                                                    {closePrice}
                                                </span>
                                            </div>
                                            <div className="stock-number d-flex align-items-baseline">
                                                <small
                                                    className={`gray-light me-1 ${
                                                        !accommodating ||
                                                        insiderFlag
                                                            ? 'opacity-50'
                                                            : ''
                                                    }`}
                                                >
                                                    融通
                                                </small>
                                                <span
                                                    className={`fingbox rounded-3 text-center ${
                                                        !accommodating ||
                                                        insiderFlag
                                                            ? 'opacity-50'
                                                            : ''
                                                    }`}
                                                >
                                                    {accommodating}
                                                    <span>%</span>
                                                </span>
                                                {highGradeCollateralSwitch &
                                                (hQFlag === 1) ? (
                                                    // 手機
                                                    <span className="tag_quality text-center text-white  ">
                                                        優
                                                    </span>
                                                ) : (
                                                    <span></span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                );
                            }
                        )}
                    </ul>

                    <div className="desk-show table-freezes overflow-auto ">
                        <table cellSpacing={0} className="table table_sty mb-1">
                            <thead>
                                <tr>
                                    <th>股票代號</th>
                                    <th>股票名稱</th>
                                    <th>張數</th>
                                    <th>
                                        <div className="h-r">
                                            收盤價
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        前一營業日收盤價
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                            </OverlayTrigger>
                                        </div>
                                    </th>
                                    <th>融通成數</th>
                                    <th>擔保品張數</th>
                                </tr>
                            </thead>
                            <tbody>
                                {collateralStockUIList.map(
                                    (
                                        {
                                            cstQty,
                                            stockNo,
                                            stockName,
                                            accommodating,
                                            stockQty,
                                            closePrice,
                                            insiderFlag,
                                            hQFlag,
                                        },
                                        index
                                    ) => {
                                        return (
                                            <tr
                                                key={`collateralStockUIList ${index}`}
                                            >
                                                <th>
                                                    {highGradeCollateralSwitch &
                                                    (hQFlag === 1) ? (
                                                        <div className="tag_quality text-center text-white  position-absolute">
                                                            優
                                                        </div>
                                                    ) : (
                                                        <span></span>
                                                    )}
                                                    <span className="co-name">
                                                        {stockNo}
                                                    </span>
                                                </th>
                                                <td>{stockName}</td>
                                                <td>
                                                    <div className="num_qut t-r3">
                                                        {stockQty}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        className={`um_price t-r ${
                                                            !accommodating ||
                                                            insiderFlag
                                                                ? 'opacity-50'
                                                                : ''
                                                        }`}
                                                    >
                                                        <span>$</span>
                                                        {closePrice}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span
                                                        className={`fingbox rounded-3 text-center ${
                                                            !accommodating ||
                                                            insiderFlag
                                                                ? 'opacity-50'
                                                                : ''
                                                        }`}
                                                    >
                                                        {accommodating}
                                                        <span>%</span>
                                                    </span>
                                                </td>
                                                <td>
                                                    {!insiderFlag ? (
                                                        !!accommodating && (
                                                            <Counter
                                                                disabled
                                                                value={
                                                                    cstQty || 0
                                                                }
                                                                stockAmount={
                                                                    (hQFlag ===
                                                                        1) &
                                                                        (highGradeCollateralSwitch ===
                                                                            true) ||
                                                                    !highGradeCollateralSwitch
                                                                        ? stockQty
                                                                        : 0
                                                                }
                                                                increase={() => {
                                                                    setCount({
                                                                        index,
                                                                        value:
                                                                            cstQty +
                                                                            1,
                                                                    });
                                                                }}
                                                                decrease={() => {
                                                                    setCount({
                                                                        index,
                                                                        value:
                                                                            cstQty -
                                                                            1,
                                                                    });
                                                                }}
                                                                onChange={e => {
                                                                    if (
                                                                        isNaN(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    ) {
                                                                        e.target.value = 0;
                                                                    }

                                                                    if (
                                                                        parseInt(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        ) >
                                                                        stockQty
                                                                    ) {
                                                                        e.target.value =
                                                                            stockQty;
                                                                    }
                                                                    setCount({
                                                                        index,
                                                                        value: +e
                                                                            .target
                                                                            .value,
                                                                    });
                                                                }}
                                                            />
                                                        )
                                                    ) : (
                                                        <b className="text-danger ps-3">
                                                            內部人
                                                        </b>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="totalbox text-end  px-md-2 pb-3">
                        <p className="price">
                            <label className="text-black2 align-text-bottom ">
                                可增加擔保品融通額度
                            </label>
                            <b className="red fs-3 ps-3">
                                <span>$</span>
                                {addCommas(removeNonNumeric(loanAmount))}
                            </b>
                        </p>
                        <p
                            className={
                                highGradeCollateralSwitch
                                    ? 'p-warn text-danger text-end fs-12'
                                    : 'd-none'
                            }
                        >
                            僅限增加優質擔保品
                        </p>
                        <p
                            className={
                                loanAmount <
                                parseInt(removeCommas(amount)) - borrowedAmount
                                    ? 'p-warn text-danger text-end fs-12'
                                    : 'd-none'
                            }
                        >
                            您輸入的擔保品不足您的借款金額，請增加擔保品或降低借款金額
                        </p>
                    </div>
                    <div className="censorbox position-relative mt-4 d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <h6 className="fw-bolder bg-white position-absolute me-3">
                            本公司於每季依擔保品及您的信用狀況進行利率審查評估
                        </h6>
                        <div className="row p-3">
                            {/* <div className="col-md-9 my-md-1 my-4  fs-15">
                            擔保品張數試算規則：
                            <br />
                            股票的 TCRI 由低至高，近 20
                            個營業日日均量(張)由高至低， 近 20
                            個營業日平均週轉率由低至高。
                        </div> */}
                            {/* <div className="col-md-3"> */}
                            <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center mt-4 mt-md-3 mb-2">
                                <div
                                    // className="btn_back m-border-0 text-end mt-2 "
                                    className="btn_cancel btn rounded-pill  text-sm-center"
                                    type="button"
                                    onClick={() => {
                                        closeLoanCstModal();
                                    }}
                                >
                                    回上一步
                                </div>
                                <button
                                    className={`btn_check btn rounded-pill w-100 text-white ${
                                        loanAmount <
                                        parseInt(removeCommas(amount)) -
                                            borrowedAmount
                                            ? 'disabled'
                                            : ''
                                    }`}
                                    type="submit"
                                >
                                    下一步
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal>
            {/* <CertModal msg={errMsg} /> */}
        </>
    );
};

export default observer(LcstModal);
